const reverseDateString = str => str.split("-").reverse().join("-")

export default reverseDateString
